// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Photo20 from './Photo20.tsx';
import Photo24 from './Photo24.tsx';
import Photo40 from './Photo40.tsx';
import Photo48 from './Photo48.tsx';

type PhotoProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Photo20,
    Photo24,
    Photo40,
    Photo48,
};

const Photo: FC<PhotoProps> = ({ variation, ...props }) => {
    const variationKey = `Photo${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Photo" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Photo;
